// extracted by mini-css-extract-plugin
export var planDisclaimer = "SeasonalPlanCard_planDisclaimer__-1cNf";
export var planSubTitle = "SeasonalPlanCard_planSubTitle__1uhDa";